<div class="urgency-boost-boosts" [formGroup]="formGroup">
  <div class="boost-groups">
    @for (group of boostGroupsArray.controls; track trackByGroupId($index, group); let i = $index) {
      <boost-group
        [groupForm]="group"
        [groupIndex]="i"
        [removable]="boostGroupsArray.length > 1"
        (removeRequested)="removeBoostGroup(i)"
        (duplicateRequested)="duplicateBoostGroup(i)">
      </boost-group>
    }
  </div>

  <pdq-button
    class="add-group-button"
    label="+ Add Group"
    variant="primary"
    size="medium"
    [fitContent]="true"
    (click)="addBoostGroup()"></pdq-button>
</div>
